import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HOME',
    component: () => import('../components/Home.vue')
  },
  {
    path: '/login',
    name: 'LOGIN',
    component: () => import('../components/Login.vue')
  },
  /*{
    path: '/categories',
    name: 'CATEGORIAS',
    component: () => import('../components/Categories.vue')
  },*/
  /*{
    path: '/products',
    name: 'PRODUCTOS',
    component: () => import('../components/Products.vue')
  },*/
  /*{
    path: '/my_products',
    name: 'MIS PRODUCTOS',
    component: () => import('../components/MyProducts.vue')
  },*/
  {
    path: '/customer_orders',
    name: 'PEDIDOS',
    component: () => import('../components/CustomerOrders.vue')
  },
  /*{
    path: '/ventas',
    name: 'VENTAS',
    props: true,
    component: () => import('../components/Ventas.vue')
  },*/
  {
    path: '/vendors_in_the_area',
    name: 'VENDEDORES_EN_LA_ZONA',
    props: true,
    component: () => import('../components/VendorsInTheArea.vue')
  },
  {
    path: '/delete_account_customer',
    name: 'ELIMINAR_CUENTA_DE_CLIENTE',
    props: true,
    component: () => import('../components/DeleteAccountCustomer.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router